import BaseComponent from "../../baseComponent.js";
import ColorUtil from "../../../core/utils/colorUtil.js";

export default class Header extends BaseComponent {
  render() {
    let inputHeaders = [];
    let otherHeaders = [];
    let key = 0;

    for (let datasetRef in this.props.inputs) {

      var headerStyle = {
        backgroundColor: this.props.inputs[datasetRef].color,
        borderColor: ColorUtil.shadeColor(this.props.inputs[datasetRef].color, -10)
      };
      inputHeaders.push(<div className="spreadsheet-input-dataset__header"
                             style={headerStyle} key={key++}>{datasetRef}</div>);
    }

    headerStyle = {
      backgroundColor: "#666666",
      borderColor: ColorUtil.shadeColor("#666666", -10)
    };

    inputHeaders.push(<div className="spreadsheet-add-input__header"
                           style={headerStyle} key={key++}>+</div>);
    headerStyle = {
      backgroundColor: this.props.localVariables.color,
      borderColor: ColorUtil.shadeColor(this.props.localVariables.color, -10)
    };
    otherHeaders.push(<div className="spreadsheet-input-dataset__header"
                           style={headerStyle} key={key++}>LOCAL VARIABLES</div>);

    headerStyle = {
      backgroundColor: this.props.globalVariables.color,
      borderColor: ColorUtil.shadeColor(this.props.globalVariables.color, -10)
    };
    otherHeaders.push(<div className="spreadsheet-input-dataset__header"
                           style={headerStyle} key={key++}>GLOBAL VARIABLES</div>);

    headerStyle = {
      backgroundColor: this.props.output.color,
      borderColor: ColorUtil.shadeColor(this.props.output.color, -10)
    };
    otherHeaders.push(<div className="spreadsheet-output-dataset__header"
                           style={headerStyle} key={key++}>OUTPUT</div>);


    let inputContainerStyle = {
      display: "flex",
      flexDirection: "row",
      minHeight: "22px",
      flex: 1
    };

    let otherContainerStyle = {
      display: "flex",
      flexDirection: "row",
      minHeight: "22px"
    };

    let inputStyle = {
      backgroundColor: "#666666",
      borderColor: ColorUtil.shadeColor("#666666", -10),
      borderBottom: 0
    };

    return (
      <div style={{display: "flex", flexDirection: "row", minHeight: "52px"}}>
        <div style={{display: "flex", flexDirection: "column", flex: 1}}>
          <div style={inputContainerStyle}>
            <div className="spreadsheet-add-input__header"
                 style={inputStyle}>INPUTS
            </div>
          </div>
          <div style={inputContainerStyle}>
            {inputHeaders}
          </div>
        </div>
        <div style={otherContainerStyle}>
          {otherHeaders}
        </div>
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/components/analytic-studio/spreadsheet/header.jsx